// extracted by mini-css-extract-plugin
export default {"continer":"Paypal_continer__How93","title":"Paypal_title__XRPpY"};